export default {
  FRONT_SITE: 'front-site',
  ADMIN_SITE: 'admin-site',
  ACCOUNT_SITE: 'account-site',
  BOM_QUOTE: 'bom-quote',
  BOM_COMPARE: 'bom-compare',
  FIND_PART: 'find-part',
  BOM_CHECK: 'bom-check',
  CHECKOUT: 'checkout',
}